module.exports = __webpack_public_path__ + "img/step6.e62a4a35.png";